<template>
  <svg
  class="eye"
    id="Calque_1"
    data-name="Calque 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 85.86 83.88"
  >
    <defs>
      <linearGradient
        id="gradient_active"
        x1="9.19"
        y1="58.11"
        x2="101.87"
        y2="60.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#51b3e3"></stop>
        <stop offset="1" stop-color="#83c06f"></stop>
      </linearGradient>

      <linearGradient
        id="gradient_sans_nom_26"
        x1="9.19"
        y1="58.11"
        x2="101.87"
        y2="60.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.24" stop-color="#f2e733"></stop>
        <stop offset="0.34" stop-color="#f2df37"></stop>
        <stop offset="0.45" stop-color="#f1c832"></stop>
        <stop offset="0.56" stop-color="#f0a433"></stop>
        <stop offset="0.8" stop-color="#ee7431"></stop>
      </linearGradient>
      <!-- <linearGradient
        id="gradient_sans_nom_26-2"
        x1="9.19"
        y1="58.14"
        x2="101.87"
        y2="60.44"
        xlink:href="#gradient_sans_nom_26"
      ></linearGradient>
      <linearGradient
        id="gradient_sans_nom_26-3"
        x1="38.42"
        y1="59.07"
        x2="94.34"
        y2="59.84"
        xlink:href="#gradient_sans_nom_26"
      ></linearGradient> -->
    </defs>
    <title>{{title}}</title>
    <path
      fill="url('#gradient_sans_nom_26')"
      class="cls-1"
      d="M59.48,70.6A11.22,11.22,0,1,1,70.7,59.38,11.23,11.23,0,0,1,59.48,70.6ZM32.58,59.38s24.87,32.51,57.38,0C57.45,26.87,32.58,59.38,32.58,59.38Z"
      transform="translate(-18.34 -17.44)"
    ></path>
    <path
      fill="url('#gradient_active')"
      class="cls-1 hover"
      :class={active}
      d="M59.48,70.6A11.22,11.22,0,1,1,70.7,59.38,11.23,11.23,0,0,1,59.48,70.6ZM32.58,59.38s24.87,32.51,57.38,0C57.45,26.87,32.58,59.38,32.58,59.38Z"
      transform="translate(-18.34 -17.44)"
    ></path>

    <path
      fill="url('#gradient_sans_nom_26')"
      class="cls-2"
      d="M64.79,61a4.86,4.86,0,0,1,0-9.72h0a9.71,9.71,0,1,0,4.38,8.11,10.18,10.18,0,0,0-.07-1.11A4.86,4.86,0,0,1,64.79,61Z"
      transform="translate(-18.34 -17.44)"
    ></path>
    <path
      fill="url('#gradient_active')"
      class="cls-2 hover"
      :class={active}
      d="M64.79,61a4.86,4.86,0,0,1,0-9.72h0a9.71,9.71,0,1,0,4.38,8.11,10.18,10.18,0,0,0-.07-1.11A4.86,4.86,0,0,1,64.79,61Z"
      transform="translate(-18.34 -17.44)"
    ></path>

    <path
      fill="url('#gradient_sans_nom_26')"
      class="cls-3"
      d="M96,34.4l-26.58-13-8.14-4L59,18.54,32.1,31.69l-7.67,3.75-6.09,3v42l8.14,4h0l26.56,13,8.21,4,2.83-1.38L91,86.79l7-3.4,6.22-3V38.41Zm5.38,44-.57.83L88.2,85.4,61.27,98.55l-6.79-3.32-26.58-13L21.17,79V40.2l.41-.61h0l13.34-6.52L61.27,20.21,68,23.5l26.58,13,6.79,3.32Z"
      transform="translate(-18.34 -17.44)"
    ></path>
    <path
      fill="url('#gradient_active')"
      class="cls-3 hover"
      :class="{active}"
      d="M96,34.4l-26.58-13-8.14-4L59,18.54,32.1,31.69l-7.67,3.75-6.09,3v42l8.14,4h0l26.56,13,8.21,4,2.83-1.38L91,86.79l7-3.4,6.22-3V38.41Zm5.38,44-.57.83L88.2,85.4,61.27,98.55l-6.79-3.32-26.58-13L21.17,79V40.2l.41-.61h0l13.34-6.52L61.27,20.21,68,23.5l26.58,13,6.79,3.32Z"
      transform="translate(-18.34 -17.44)"
    ></path>    

  </svg>

</template>
<script>
export default {
  name: "eye",
  props: {
    title: String,
    active: Boolean
  },
  mounted() {
    
  }
};
</script>
<style scoped lang="sass">
svg:hover path.hover, svg path.active
  opacity: 1 !important

svg path.hover
  opacity: 0.0;
  transition: opacity .4s ease;
</style>
